import request from '@/utils/request'

// 意见反馈列表页--分页列表
export function pageCustomerService(params) {
  return request({
    url: '/v3/manager/customer/pageCustomerService',
    method: 'post',
    data: params
  })
}
// 意见反馈列表页--上传图片
export function uploadImg(params) {
  var formData = new FormData()
  formData.append('multipartFile', params.raw)
  return request({
    url: '/v3/manager/customer/uploadImg',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}
// 查询sn绑定状态信息
export function checkSn(params) {
  return request({
    url: '/v3/manager/customer/checkSn?deviceSn=' + params.sn,
    method: 'get',
    data: params
  })
}
// 意见反馈--提交
export function addCustomerService(params) {
  return request({
    url: '/v3/manager/customer/addCustomerService',
    method: 'post',
    data: params
  })
}
// 意见反馈--列表中改状态--提交
export function updateCustomerServiceStatus(params) {
  return request({
    url: '/v3/manager/customer/updateCustomerServiceStatus',
    method: 'post',
    data: params
  })
}
// 意见反馈--详情页--根据id获取问题详情
export function getCustomerServiceById(params) {
  return request({
    url: '/v3/manager/customer/getCustomerServiceById?id=' + params.id,
    method: 'get',
    data: params
  })
}
// 意见反馈--详情页--获取回复列表
export function listCustomerServiceDetail(params) {
  return request({
    url: '/v3/manager/customer/listCustomerServiceDetail?cid=' + params.id,
    method: 'get',
    data: params
  })
}
// 意见反馈--详情页--回复售后问题
export function addCustomerServiceDetail(params) {
  return request({
    url: '/v3/manager/customer/addCustomerServiceDetail',
    method: 'post',
    data: params
  })
}
// 意见反馈列表页--提交处理客户反馈
export function updateFeedback(params) {
  return request({
    url: '/v3/manager/unauth/updateFeedback',
    method: 'post',
    data: params
  })
}
// 用户信息
export function userV3PageList(params) {
  return request({
    url: '/v3/user/user/userV3PageList',
    method: 'post',
    data: params
  })
}
// 编辑用户信息0--提交
export function updateById(params) {
  return request({
    url: '/v3/user/user/updateById',
    method: 'post',
    data: params
  })
}
// 修改用户密码--提交
export function resetPassword(params) {
  return request({
    url: '/v3/user/user/resetPassword',
    method: 'post',
    data: params
  })
}
